module.exports = __webpack_public_path__ + "static/media/Sarabun-Regular.49d082d0.ttf";